import { useEffect, useRef, useState } from 'react';

import { FilterSearchIcon } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';

import {
  CollapsableNameFilterInputWrapper,
  MultiSelectionFilterWrapper,
  MultiSelectionItemsWrapper,
  SearchInFiltersInput,
  ShowMoreWrapper,
} from './MultiSelectionFilterStyle';
import { ListingFilterItemInterface, MultiSelectionFilterProps } from './types';
import MultiSelectionItem from './MultiSelectionFilterItem';

const MultiSelectionFilter = ({
  data,
  handleSelectedItems,
  selectedItems,
  singleItemClassName,
  subTitleKey = 'subTitle',
}: MultiSelectionFilterProps) => {
  const wrapperRef = useRef(null);
  const [showMore, setShowMore] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [filteredData, setFilteredData] =
    useState<ListingFilterItemInterface[]>(data);

  useEffect(() => {
    if (searchText) {
      const filtered = data?.filter((item) => {
        return item.value
          ?.toLowerCase()
          .includes(searchText?.toLocaleLowerCase('tr-TR'));
      });
      setFilteredData(filtered);
    } else {
      setFilteredData(data);
    }
  }, [searchText, data]);

  return (
    <MultiSelectionFilterWrapper>
      <CollapsableNameFilterInputWrapper className='listing-hotel-name-filter'>
        <SearchInFiltersInput
          placeholder='Ara'
          value={searchText}
          onChange={setSearchText}
          icon={
            <CustomIcon
              icon={FilterSearchIcon}
              fontSize={20}
              style={{ marginRight: '4px' }}
            />
          }
          iconLeft={true}
          useNative
        />
      </CollapsableNameFilterInputWrapper>

      <MultiSelectionItemsWrapper ref={wrapperRef} isShowMore={showMore}>
        {showMore
          ? filteredData?.map((item: ListingFilterItemInterface) => (
              <MultiSelectionItem
                key={item.key?.toString()}
                item={item}
                value={selectedItems.includes(item.key)}
                onChange={(selected) => {
                  item.selected = selected;
                  const newSelectedItems = selected
                    ? [...selectedItems, item.key]
                    : selectedItems.filter((sKey) => sKey !== item.key);
                  handleSelectedItems(newSelectedItems);
                }}
                subTitleKey={subTitleKey}
                singleItemClassName={singleItemClassName}
              />
            ))
          : filteredData
              ?.slice(0, 5)
              .map((item: ListingFilterItemInterface) => (
                <MultiSelectionItem
                  key={item.key?.toString()}
                  item={item}
                  value={selectedItems.includes(item.key)}
                  onChange={(selected) => {
                    item.selected = selected;
                    const newSelectedItems = selected
                      ? [...selectedItems, item.key]
                      : selectedItems.filter((sKey) => sKey !== item.key);
                    handleSelectedItems(newSelectedItems);
                  }}
                  subTitleKey={subTitleKey}
                  singleItemClassName={singleItemClassName}
                />
              ))}
      </MultiSelectionItemsWrapper>
      {!searchText && filteredData.length > 5 ? (
        <ShowMoreWrapper onClick={() => setShowMore(!showMore)}>
          {showMore ? 'Daha Az Göster' : 'Daha Fazla Göster'}
        </ShowMoreWrapper>
      ) : null}
    </MultiSelectionFilterWrapper>
  );
};

export default MultiSelectionFilter;
